import { CommentFeed } from "src/components/comments/CommentFeed";
import { useGetCommentsQuery } from "src/components/comments/CommentsSuperDrawer.generated";
import { queryResult } from "src/utils";

type ChangeEventWorkflowCommentsProps = { changeEventId: string };

export function ChangeEventWorkflowComments(props: ChangeEventWorkflowCommentsProps) {
  const { changeEventId } = props;
  const query = useGetCommentsQuery({ variables: { commentableId: changeEventId } });
  return queryResult(query, ({ commentable }) => (
    // The right pane already titles itself "Comments", and there's no room for the followers button
    <CommentFeed commentable={commentable} showFollowers={false} showCommentTitle={false} />
  ));
}
